import { PrincipalType } from '@entities/shared/account';

import { requirePrincipalType } from '../../require-principal-type';

// tenant-бакет: гейт на тип принципала (Tenant). Per-segment доступ додатково
// вирішується через requirePermission(Resource) (Tenant.* ресурси) всередині сегментів.
export const tenantLoader = requirePrincipalType(PrincipalType.Tenant);
